
export function boilerplateNavMain(options = {}){
    const defaultOptions = {
        mobileBreakpoint: 1000,
        submenuTransitionMs: 500,
        megaMenuTransitionMs: 500,
    };
    options = { ...defaultOptions, ...options };

    const $navMain = document.querySelector('.nav-main');
    const $topLevels = $navMain.querySelectorAll('.nav-main__item');
    const $navMainLinks = $navMain.querySelectorAll('.nav-main__item a');
    const $navToggle = document.querySelector('.toggle-nav-main');
    let winWidth = window.innerWidth;
    let timeout_resize = null;

    // ========== helper functions ==========
    function isDesktop() {
        return window.innerWidth >= options.mobileBreakpoint;
    }

    function closeItem($item) {
        if (!$item.classList.contains('active') || $item.classList.contains('transition-out')) return;

        $item.classList.add('transition-out');

        window.setTimeout(() => {
            $item.classList.remove('active', 'transition-out');
            megaMenu.afterItemClosed();
        }, options.submenuTransitionMs);
    }

    function setupNavMainMegaMenu() {
        const $megaBackdrop = document.querySelector('#main-nav-mega-backdrop');

        function isMega($el) {
            return $el.classList.contains('type-megaMenu');
        }

        function hasOpenMega() {
            return [...$topLevels].some(($el) => isMega($el) && $el.classList.contains('active'));
        }

        function willHaveOpenMega() {
            return [...$topLevels].some(($el) => (
                isMega($el) &&
                $el.classList.contains('active') &&
                !$el.classList.contains('transition-out')
            ));
        }

        function setBackdropHeight($item) {
            if (!$megaBackdrop) return;

            const $header = $megaBackdrop.closest('.site-header');
            const $panel = $item?.querySelector('.container--mega-menu');
            const headerHeight = $header ? $header.offsetHeight : 0;
            const panelHeight = $panel ? $panel.offsetHeight : 0;
            $megaBackdrop.style.setProperty('--mega-backdrop-h', (headerHeight + panelHeight) + 'px');
        }

        function beginExit() {
            if (!document.body.classList.contains('nav-main--mega-active')) return;
            document.body.classList.add('nav-main--mega-transition-out');
        }

        function clear() {
            if ($megaBackdrop) {
                $megaBackdrop.style.transition = 'none';
                $megaBackdrop.style.setProperty('--mega-backdrop-h', '0px');
                $megaBackdrop.offsetWidth;
            }

            document.body.classList.remove('nav-main--mega-active', 'nav-main--mega-transition-out');

            if ($megaBackdrop) {
                $megaBackdrop.offsetWidth;
                $megaBackdrop.style.transition = '';
            }
        }

        function afterOpen($item) {
            if (isMega($item)) {
                document.body.classList.remove('nav-main--mega-transition-out');
                const wasMegaOpen = document.body.classList.contains('nav-main--mega-active');
                setBackdropHeight($item);

                if (!wasMegaOpen && $megaBackdrop) {
                    $megaBackdrop.offsetWidth;
                    document.body.classList.add('nav-main--mega-active');
                }
                return;
            }

            if (!willHaveOpenMega()) beginExit();
        }

        function afterCloseAttempt() {
            if (!willHaveOpenMega()) beginExit();
        }

        function afterItemClosed() {
            if (!hasOpenMega()) clear();
        }

        function reset() {
            clear();
        }

        function syncHeight() {
            const $openMega = [...$topLevels].find(($el) => isMega($el) && $el.classList.contains('active'));
            if ($openMega) setBackdropHeight($openMega);
        }

        return { afterOpen, afterCloseAttempt, afterItemClosed, reset, syncHeight };
    }

    const megaMenu = setupNavMainMegaMenu();

    $navMainLinks.forEach($el => {
        $el.addEventListener('click', function(e){
            const $thisClosestSubmenu = e.target.closest('.nav-main__item__submenu');

            if ( !$thisClosestSubmenu ) {
                const $thisTopLevel = e.target.closest('.nav-main__item');
                const $thisSubmenu = $thisTopLevel.querySelector('.nav-main__item__submenu');

                if ( $thisSubmenu ) {
                    if (!isDesktop()) return;

                    e.preventDefault();
                    e.stopPropagation();

                    if ($thisTopLevel.classList.contains('active')) {
                        closeItem($thisTopLevel);
                        megaMenu.afterCloseAttempt();
                    } else {
                        $topLevels.forEach($el => {
                            if ( $el != $thisTopLevel ) {
                                closeItem($el);
                            }
                        });
                        $thisTopLevel.classList.add('active');
                        megaMenu.afterOpen($thisTopLevel);
                    }
                }
            }
        });
    });

    $navToggle.addEventListener('click', function(e){
        e.preventDefault();
        document.body.classList.toggle('nav-main--active');
    });

    document.addEventListener('click', function(e){
        if ( isDesktop() && !e.target.closest('.nav-main__item') ) {
            $topLevels.forEach(closeItem);
            megaMenu.afterCloseAttempt();
        }
    });

    function doResetNav(){
        const wasDesktop = winWidth >= options.mobileBreakpoint;
        const nowDesktop = isDesktop();

        if ( wasDesktop !== nowDesktop ) {
            document.body.classList.remove('nav-main--active');
            $topLevels.forEach(el => el.classList.remove('active', 'transition-out'));
            megaMenu.reset();
        } else if (nowDesktop) {
            megaMenu.syncHeight();
        }

        winWidth = window.innerWidth;
    }

    window.addEventListener('resize', function(){
        window.clearTimeout(timeout_resize);
        timeout_resize = window.setTimeout(doResetNav, 200);
    });
}
